import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import "../Styles/Concept.css";
export default function Concept() {
  const navigate = useNavigate();

  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchConcepts();
  }, []);

  const fetchConcepts = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(`${API.BASE_URL}/Concepts.php`);

      const result = await response.json();

      if (result.success) {
        setFolders(result.data || []);
      } else {
        setError(result.message || "Unable to load concepts.");
      }
    } catch (error) {
      console.error("Concept fetch error:", error);

      setError("Unable to load concepts.");
    } finally {
      setLoading(false);
    }
  };

  const openFolder = (folderName) => {
    navigate(`/concepts/${encodeURIComponent(folderName)}`);
  };

  if (loading) {
    return <div className="concept-loading">Loading concepts...</div>;
  }

  if (error) {
    return <div className="concept-error">{error}</div>;
  }

  return (
    <div className="concept-page">
      <div className="concept-header">
        <h2>Concepts</h2>

        <p>Explore all embroidery concepts</p>
      </div>

      {folders.length === 0 ? (
        <div className="concept-empty">No concepts found.</div>
      ) : (
        <div className="concept-grid">
          {folders.map((folder) => (
            <div
              className="concept-card"
              key={folder.name}
              onClick={() => openFolder(folder.name)}
            >
              <div className="concept-image-wrapper">
                <img
                  src={folder.cover}
                  alt={folder.name}
                  className="concept-image"
                  loading="lazy"
                />
                <div className="image-count">
                  <i className="bi bi-images me-1"></i>+{folder.image_count}
                </div>

                <div className="concept-image-overlay">
                  <span>View Designs</span>
                </div>
              </div>

              <div className="concept-card-content">
                <h3>{folder.name}</h3>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
